import { useQuery } from 'react-query'
import badaConfigApi from '../../utils/badaConfigApi'

const useBrandConfig = (brand) =>
  useQuery(brand, () => badaConfigApi.getBrandConfig(brand), {
    retry: 2,
  })

export default useBrandConfig
